module.exports = __webpack_public_path__ + "img/undraw_make_it_rain_iwk4.f44d4221.svg";